<script setup lang="ts">
const props = defineProps(['feedback'])
const { t } = useI18n()
const errorContainer = ref(null)
let initialLoad = true

watch(
  () => props.feedback,
  async (newFeedback, oldFeedback) => {
    await nextTick()

    // Solo hacer scroll si:
    // 1. Hay nuevos errores Y
    // 2. Es la primera carga O hay cambios reales en los errores
    if (
      newFeedback?.length &&
      errorContainer.value &&
      (initialLoad || JSON.stringify(newFeedback) !== JSON.stringify(oldFeedback))
    ) {
      errorContainer.value.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      })
      initialLoad = false
    }
  },
  { deep: true }
)
</script>

<template>
  <div class="text-danger" v-if="feedback?.length" ref="errorContainer">
    <ul class="list-unstyled mb-0">
      <li v-for="(item, index) in feedback" :key="index">
        <small>{{ t(item) }}</small>
      </li>
    </ul>
  </div>
</template>
